import { APP_ROUTES } from "../constants";

export const TechnologyUtil = {
  buildTechnologyDetailPath,
};

function buildTechnologyDetailPath(solutionCode: string): string {
  return solutionCode
    ? APP_ROUTES.PAGEMANAGEMENT.TECHNOLOGY.DETAIL.replace(":solutionCode", solutionCode)
    : APP_ROUTES.PAGEMANAGEMENT.TECHNOLOGY.BASE;
}
